import React from 'react'
import { connect } from 'react-redux'

import {
     selectShippingMethodAsync, 
     updateShippingMethodsAsync
} from './shippingMethodActions'

import {
  OptionListItemRadio,
  CheckoutSection,
  hiddenAnchorStyle,
  SpinnerWhenInvalid
} from '../../components'

import { Fade } from '../../componentAnimations'
import { TranslationUtility } from "../../../util/translationUtility";

const getSelectedShippingMethod = (methods, id) =>
  methods.filter(m => m.Id === id)[0];

let shippingDependenciesChanged = function() {};

class CheckoutShipment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
       isCollapsed: getSelectedShippingMethod(props.shippingMethods, props.selectedShippingMethodId)
    }
    this.onSelected = this.onSelected.bind(this)
    this.translationUtility = new TranslationUtility(props.localizationItems);
  }

  componentDidUpdate(prevProps) {
    if (shippingDependenciesChanged(prevProps, this.props)) {
        this.props.updateShippingMethods(this.props.selectedShippingAddressId);
    }
  }

  onClickChange(e) {
    e.preventDefault();
    this.setState({ isCollapsed: !this.state.isCollapsed });
  }

  onSelected(id) {
    this.setState({ isCollapsed: true });
    this.props.onSelected(id);
  }

  render() {
    const shippingMethods = this.props.shippingMethods;
    const selectedId = this.props.selectedShippingMethodId;
    const selectedMethod = getSelectedShippingMethod(shippingMethods, selectedId);
    const canChange = shippingMethods.length > 1 || !selectedMethod;
    const hasCurrentShippingAddress =
        !!this.props.selectedShippingAddressId && this.props.selectedShippingAddressId !== '';
    const items = /*!this.state.isCollapsed && */shippingMethods.map(sm => {
      return (
        <OptionListItemRadio
          id={sm.Id}
          key={sm.Id}
          isSelected={(sm.Id === selectedId)}
          onClick={this.onSelected}
          label={sm.NameWithPrice}
          enabled={hasCurrentShippingAddress}
        />
      );
    });
    return (
      <CheckoutSection label={this.translationUtility.translateResourceString("/Checkout/ShippingMethod")} hidden={false}>
        <SpinnerWhenInvalid isInvalid={this.props.shippingIsInvalid} >
          {selectedMethod &&
            <div style={{ lineHeight: 2 }}>
              <a
                href=""
                style={hiddenAnchorStyle}
                onClick={(e) => this.onClickChange(e)}
              >
                {selectedMethod.NameWithPrice}
                {canChange &&
                  <span style={{ marginLeft: 20, color: '#3cb7e3' }}>
                    {this.state.isCollapsed ? "Change" : "Done"}
                  </span>}
              </a>
            </div>}
          {shippingMethods.length === 0 &&
            <div>Sorry, but no shipping methods are available for your shipping address. To ship outside of the US, please log in.</div>}

          <Fade inProp={!this.state.isCollapsed}>
            <div>{items}</div>
          </Fade>
        </SpinnerWhenInvalid>
      </CheckoutSection>);
  }
}

const cartItemsTotalWeight = (cartItems) => (cartItems.reduce((acc, item) => acc + item.Weight * item.Quantity, 0));

shippingDependenciesChanged = (oldProps, newProps) => {
    var {
        selectedShippingAddressId: oldAddress,
        cartItems: oldCartItems
    } = oldProps;
    var {
        selectedShippingAddressId: newAddress,
        cartItems: newCartItems
    } = newProps;
    return oldAddress !== newAddress || cartItemsTotalWeight(oldCartItems) !== cartItemsTotalWeight(newCartItems);
}

const mapCheckoutShipmentStateToProps = (state) => {
    return {
        shippingMethods: state.entities.ShippingOptions,
        selectedShippingMethodId: state.entities.SelectedShippingOptionId,
        selectedShippingAddressId: state.entities.SelectedShippingAddressId,
        shippingIsInvalid: state.ui.isShippingPending,
        cartItems: state.entities.CartItems,
        localizationItems: state.constants.localizationItems
    }
}

const mapCheckoutShipmentDispatchToProps = (dispatch) => {
  return {
    onSelected: (id) => dispatch(selectShippingMethodAsync({ shippingMethodId: id })),
    updateShippingMethods: (addressId) => dispatch(updateShippingMethodsAsync({ addressId: addressId }))
  }
}

const CheckoutShipmentContainer = connect(mapCheckoutShipmentStateToProps, mapCheckoutShipmentDispatchToProps)(CheckoutShipment);

export default CheckoutShipmentContainer


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/ShippingMethod/CheckoutShipment.jsx